import { create } from "zustand";

export type TypeFilter =
  | "all"
  | "recents"
  | "files"
  | "commands"
  | "references"
  | "settings";

type CommandPaletteStore = {
  open: boolean;
  typeFilter: TypeFilter;
  setOpen: (open: boolean) => void;
  setTypeFilter: (typeFilter: TypeFilter) => void;
  toggle: () => void;
};

export const useCommandPaletteStore = create<CommandPaletteStore>((set) => ({
  open: false,
  typeFilter: "all",
  setOpen: (open) => set({ open, typeFilter: open ? "all" : "all" }),
  setTypeFilter: (typeFilter) => set({ typeFilter }),
  toggle: () =>
    set((state) => ({
      open: !state.open,
      typeFilter: state.open ? "all" : state.typeFilter,
    })),
}));
